module.exports = __webpack_public_path__ + "img/testimonial_3.5aad2a4f.png";